export default "__VITE_ASSET__CnpC_6tP__"